export default __webpack_public_path__ + "static/media/2020-1.dacec22a.jpeg";